<template>
  <footer class="edit-ticket-footer">
    <section class="edit-ticket-footer__dates">
      <p>{{ selectedTicketCreatedDate }}</p>
      <p>{{ selectedTicketLastModifiedDate }}</p>
    </section>
    <section v-if="store.getters.hasErrandEditorAccess" class="edit-ticket-footer__buttons">
      <ButtonOutline
        :buttonText="t('general__text__cancel')"
        @onClicked="emits('cancelEditTicket')"
      />
      <ButtonPrimary
        :buttonText="`${t('general__text__update')} ${t(
          'general__data__ticket-the'
        ).toLowerCase()}`"
        :disabled="disableSaveButton"
        @onClicked="emits('updateTicket')"
      />
    </section>
  </footer>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { computed, inject } from 'vue'
import ButtonOutline from '@/design-system/atoms/buttons/ButtonOutline.vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import { UpdateTicket } from '@/services/tickets.service'

interface EMITS {
  (e: 'cancelEditTicket'): void
  (e: 'updateTicket'): void
}
const emits = defineEmits<EMITS>()

const props = defineProps<{
  createdDate: string
  lastModifiedDate: string
}>()

const { t } = useI18n()
const store = useStore()
const formData = inject<UpdateTicket>('formDataEditErrand')

const createdDate = computed<string>(() => props.createdDate)
const disableSaveButton = computed(() => {
  return (
    !formData?.title?.length ||
    !formData?.typeId ||
    !formData?.categoryId ||
    !formData?.status ||
    !formData?.priority
  )
})
const lastModifiedDate = computed<string>(() => props.lastModifiedDate)

const selectedTicketCreatedDate = computed<string>(() =>
  createdDate.value.length
    ? t('general__text__created-was') + ' ' + formatDate(createdDate.value)
    : ''
)
const selectedTicketLastModifiedDate = computed<string>(() =>
  lastModifiedDate.value.length
    ? t('general__text__updated-was') + ' ' + formatDate(lastModifiedDate.value)
    : ''
)

function formatDate(value: string) {
  return new Date(value).toLocaleDateString('sv-SE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/mixins.scss';

.edit-ticket-footer {
  align-items: center;
  display: flex;
  height: 48px;
  &__dates {
    display: flex;
    flex-direction: column;
    gap: 4px;
    p {
      @include font-mixins.desktop-regular-tiny;
      color: variables.$color-greyscale-secondary;
      margin: 0;
    }
  }
  &__buttons {
    display: flex;
    gap: 16px;
    margin-left: auto;
  }
}
</style>
